import React, { useState } from 'react'
import { useDispatch } from 'hooks/use-redux'
import type { PlaylistTag } from 'types/playlist'
import {
  createPlaylistTag,
  editPlaylistTag,
} from '@disco/state-management/actions/PlaylistTagActions'
import { COLOR_INDICATORS } from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import ColorIndicatorsAlert from 'components/common/color-indicators-alert'
import { Box } from 'components/ds'
import DialogFooter from 'components/modals/dialog-footer'
import Button from 'components/ui/button'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import TextField from 'components/ui/text-field'
type Props = {
  editingTag?: PlaylistTag
  onRequestClose: () => void
}

const PlaylistTagEditModal = (props: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const colorIndicatorsEnabled = useFeatureEnabled(COLOR_INDICATORS)
  const { editingTag, onRequestClose } = props
  const [name, setName] = useState<string>(editingTag?.name ?? '')
  const [saving, setSaving] = useState<boolean>(false)
  const [errors, setErrors] = useState<
    Record<string, string> | null | undefined
  >(null)

  const handleSubmit = async () => {
    const errors: Record<string, string> = {}
    if (!name) errors.name = 'Please input a name'

    if (Object.keys(errors).length) {
      return setErrors(errors)
    }

    if (name) {
      setErrors(null)
      setSaving(true)

      try {
        if (editingTag) {
          const tag = { ...editingTag, name }
          await dispatch(editPlaylistTag(tag))
        } else {
          await dispatch(createPlaylistTag(name))
        }

        onRequestClose()
      } catch (error) {
        // TODO: Show error from server response (server returns 500)
      }

      setSaving(false)
    }
  }

  return (
    <ModalWindow
      header={
        <Heading>
          {editingTag ? (
            <span>Edit playlist tag</span>
          ) : (
            <span>Create playlist tag</span>
          )}
        </Heading>
      }
      actions={
        <DialogFooter
          onClose={onRequestClose}
          primary={
            <Button
              appearance="primary"
              caption={editingTag ? 'Save' : 'Create'}
              disabled={editingTag ? editingTag?.name === name : !name}
              progressCaption={editingTag ? 'Saving' : 'Creating'}
              progressIndicator={saving}
              onClick={handleSubmit}
            />
          }
        />
      }
      onClose={onRequestClose}
      width="small"
      isOpen
    >
      {!colorIndicatorsEnabled && (
        <Box mb="4">
          <ColorIndicatorsAlert />
        </Box>
      )}
      <Box mb="4">
        <TextField
          autoFocus
          error={errors?.name}
          label="Tag name"
          placeholder="Enter tag name"
          value={name}
          onChange={event => setName(event.target.value)}
        />
      </Box>
    </ModalWindow>
  )
}

export default PlaylistTagEditModal
